module.exports = __webpack_public_path__ + "static/media/natemat.36656d88.svg";